import styled from "styled-components";
import * as colors from "../../../styles/shared/colors";
import Button from "../../Button";
import externalArrowWhiteWithDots from "../../../assets/icon-colors/external-arrow-white-with-dots.svg";

export const ModalPopUp = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  background: rgba(38, 38, 38, 0.6);
  backdrop-filter: blur(8px);
`;

export const ModalContent = styled.div`
  background-color: ${colors.white};
  padding: 64px 85px;
  text-align: center;
  position: relative;
  border-radius: 10px;

  @media (max-width: 768px) {
    margin-left: 20px;
    margin-right: 20px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .modal-button {
    font-weight: 700;
    border-radius: 4px;
  }

  button:nth-last-child(1) {
    color: ${colors.white};
    margin: 25px 25px 0;
    margin-top: 10px;
  }

  p {
    margin-bottom: 8px;
    color: ${colors.charcoal2};
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }
`;

export const ModalClose = styled.button`
  position: absolute;
  right: 10px;
  top: 5px;
  height: 40px;
  padding-top: 32px;

  border: none;
  background: transparent;
  cursor: pointer;

  color: ${colors.brandBlueDark};
  font-size: 10px;
  font-weight: 700;

  &:before,
  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    content: "";
    height: 22px;
    width: 3px;
    background-color: ${colors.brandBlueDark};
  }

  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
    border-radius: 8px;
  }

  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
    border-radius: 8px;
  }
`;

export const LightBlueButton = styled(Button)`
  background: ${colors.primaryButtonBlueLight};
  font-size: 18px;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 4px;
  line-height: 22px;
  margin: 0 !important;

  &:hover {
    background: ${colors.primaryButtonBlue};
  }
`;

export const ArrowWhiteBtn = styled.div`
  background-image: url(${externalArrowWhiteWithDots});
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  height: 16px;
  width: 16px;
  margin-left: 12px;
  margin-top: 3px;
`;
